"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _savings = require("./utils/savings");
var _sliders = _interopRequireDefault(require("./sliders"));
var _savingsOutput = _interopRequireDefault(require("./savings-output"));
var _graphSlider = _interopRequireDefault(require("./graph-slider"));
var _react2 = require("@linaria/react");
var _button = _interopRequireDefault(require("@ux/button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const CalculatorWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CalculatorWrapper",
  class: "pl-c1a053g9"
});
const TopContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TopContainer",
  class: "pl-tbbzog0"
});
const SlidersWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SlidersWrapper",
  class: "pl-s1ltknut"
});
const SavingWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SavingWrapper",
  class: "pl-s8ihyru"
});
const GraphSliderWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GraphSliderWrapper",
  class: "pl-got26od",
  vars: {
    "got26od-0": [props => props.topOffset, "px"]
  }
});
const StyledButton = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "StyledButton",
  class: "pl-s14khdyh"
});
const SavingsCalculator = ({
  slidersContent,
  outputContent,
  graphContent,
  defaultValues = {
    years: 3,
    sales: 500000,
    ratio: 50,
    transactions: 50000
  },
  screenSettings,
  clickHandler,
  eid
}) => {
  const {
    height: screenHeight,
    width: screenWidth,
    isMobile
  } = screenSettings;
  const desktopGraphHeight = 670;
  const desktopGraphEndOffset = 142;
  const mobileGraphHeight = 350;
  const mobileGraphEndOffset = 56;
  const wrapperRef = (0, _react.useRef)();
  const topWrapperRef = (0, _react.useRef)();
  const [width, setWidth] = (0, _react.useState)(0);
  const [topOffset, setTopOffset] = (0, _react.useState)(0);
  const [sales, setSales] = (0, _react.useState)(defaultValues.sales);
  const [transactions, setTransactions] = (0, _react.useState)(defaultValues.transactions);
  const [ratio, setRatio] = (0, _react.useState)(defaultValues.ratio);
  const [years, setYears] = (0, _react.useState)(defaultValues.years);
  const maxSavingValue = (0, _savings.getSavings)({
    sales: slidersContent.salesMaxValue,
    ratio: slidersContent.ratioMinValue,
    years: 1,
    transactions: slidersContent.transactionsMaxValue
  });
  const onResize = () => {
    const wrapperPaddingLeft = parseFloat(getComputedStyle(wrapperRef.current).paddingLeft || 0);
    const {
      width: wrapperWidth
    } = wrapperRef.current?.getBoundingClientRect() ?? {};
    const {
      height: topWrapperHeight
    } = topWrapperRef.current?.getBoundingClientRect() ?? {};
    setWidth(wrapperWidth - wrapperPaddingLeft);
    setTopOffset(-topWrapperHeight);
  };
  (0, _react.useEffect)(() => {
    onResize();
  }, [screenHeight, screenWidth]);
  const heightRate = (0, _savings.getSavings)({
    sales,
    transactions,
    ratio,
    years: 1
  }) / maxSavingValue;
  const savings = (0, _savings.getSavings)({
    sales,
    transactions,
    ratio,
    years
  });
  const handleButtonClick = () => clickHandler({
    sales,
    ratio,
    transactions
  });
  return /*#__PURE__*/_react.default.createElement(CalculatorWrapper, {
    ref: wrapperRef,
    "data-cy": "savings-calculator-wrapper"
  }, /*#__PURE__*/_react.default.createElement(TopContainer, {
    ref: topWrapperRef
  }, !isMobile && /*#__PURE__*/_react.default.createElement(SlidersWrapper, null, /*#__PURE__*/_react.default.createElement(_sliders.default, (0, _extends2.default)({}, slidersContent, {
    ratio: ratio,
    sales: sales,
    transactions: transactions,
    onSalesChange: setSales,
    onRatioChange: setRatio,
    onTransactionsChange: setTransactions
  }))), /*#__PURE__*/_react.default.createElement(SavingWrapper, {
    "data-cy": "savings-calculator-output"
  }, /*#__PURE__*/_react.default.createElement(_savingsOutput.default, (0, _extends2.default)({}, outputContent, {
    totalSavings: savings,
    clickHandler: handleButtonClick,
    years: years,
    isMobile: isMobile,
    eid: eid
  })))), width && !isMobile && /*#__PURE__*/_react.default.createElement(GraphSliderWrapper, {
    topOffset: topOffset
  }, /*#__PURE__*/_react.default.createElement(_graphSlider.default, (0, _extends2.default)({}, graphContent, {
    startStep: years,
    width: width,
    height: isMobile ? mobileGraphHeight : desktopGraphHeight,
    onChange: setYears,
    defaultEndOffset: isMobile ? mobileGraphEndOffset : desktopGraphEndOffset,
    heightRate: heightRate
  }))), isMobile && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SlidersWrapper, null, /*#__PURE__*/_react.default.createElement(_sliders.default, (0, _extends2.default)({}, slidersContent, {
    ratio: ratio,
    sales: sales,
    transactions: transactions,
    onSalesChange: setSales,
    onRatioChange: setRatio,
    onTransactionsChange: setTransactions
  }))), /*#__PURE__*/_react.default.createElement(StyledButton, {
    className: "rounded",
    design: "primary",
    text: outputContent.buttonText,
    onClick: clickHandler,
    "data-cy": "savings-calculator-action-button",
    "data-eid": eid
  })));
};
SavingsCalculator.propTypes = {
  slidersContent: _propTypes.default.object,
  outputContent: _propTypes.default.object,
  graphContent: _propTypes.default.object,
  defaultValues: _propTypes.default.object,
  screenSettings: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    isMobile: _propTypes.default.bool
  }),
  clickHandler: _propTypes.default.func,
  eid: _propTypes.default.string
};
var _default = exports.default = SavingsCalculator;